<!--<c-footer>-->
  <div>
    <span class="ml-auto">v{{backofficeVersion}}</span>
  </div>
<!--</c-footer>-->
